var installedModules = {};
var moduleToHandlerMapping = {
	61229: {
		getter: () => (() => (__webpack_require__(96540))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	76391: {
		getter: () => (() => (__webpack_require__(40961))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	53008: {
		getter: () => (__webpack_require__.e(5556).then(() => (() => (__webpack_require__(5556))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^15.8.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "prop-types",
	},
	4550: {
		getter: () => (Promise.all([__webpack_require__.e(2843), __webpack_require__.e(3008)]).then(() => (() => (__webpack_require__(2843))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.4.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-transition-group",
	},
	79705: {
		getter: () => (Promise.all([__webpack_require__.e(5655), __webpack_require__.e(1777)]).then(() => (() => (__webpack_require__(54158))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^11.11.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/react",
	},
	59883: {
		getter: () => (__webpack_require__.e(9680).then(() => (() => (__webpack_require__(37299))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.0.0-beta",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/awsui-component-toolkit",
	},
	64507: {
		getter: () => (__webpack_require__.e(9755).then(() => (() => (__webpack_require__(9755))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/awsui-collection-hooks",
	},
	64761: {
		getter: () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(80436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^10.2.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "intl-messageformat",
	},
	86400: {
		getter: () => (__webpack_require__.e(150).then(() => (() => (__webpack_require__(90150))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.23.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "date-fns",
	},
	28250: {
		getter: () => (__webpack_require__.e(9308).then(() => (() => (__webpack_require__(79308))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "uuid",
	},
	73983: {
		getter: () => (Promise.all([__webpack_require__.e(5588), __webpack_require__.e(7767)]).then(() => (() => (__webpack_require__(47767))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.4.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	57411: {
		getter: () => (__webpack_require__.e(6765).then(() => (() => (__webpack_require__(6765))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "jwt-decode",
	},
	72157: {
		getter: () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(80346))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^31.3.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ag-grid-community",
	},
	98308: {
		getter: () => (__webpack_require__.e(5821).then(() => (() => (__webpack_require__(68202))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^11.11.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/styled",
	},
	3244: {
		getter: () => (__webpack_require__.e(6875).then(() => (() => (__webpack_require__(66875))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^31.3.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ag-grid-react",
	},
	12281: {
		getter: () => (__webpack_require__.e(943).then(() => (() => (__webpack_require__(60943))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.2.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "short-uuid",
	},
	19310: {
		getter: () => (__webpack_require__.e(8094).then(() => (() => (__webpack_require__(78094))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	19629: {
		getter: () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.17.21",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	20630: {
		getter: () => (__webpack_require__.e(2505).then(() => (() => (__webpack_require__(72505))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.21.4",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	22048: {
		getter: () => (Promise.all([__webpack_require__.e(5373), __webpack_require__.e(2634)]).then(() => (() => (__webpack_require__(55373))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "qs",
	},
	22082: {
		getter: () => (__webpack_require__.e(9828).then(() => (() => (__webpack_require__(9828))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dateformat",
	},
	26200: {
		getter: () => (__webpack_require__.e(4847).then(() => (() => (__webpack_require__(37228))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.1.8",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-cache-buster",
	},
	28285: {
		getter: () => (Promise.all([__webpack_require__.e(5588), __webpack_require__.e(4976)]).then(() => (() => (__webpack_require__(84976))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.4.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	29095: {
		getter: () => (__webpack_require__.e(7310).then(() => (() => (__webpack_require__(67310))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-infinite-scroll-component",
	},
	33171: {
		getter: () => (__webpack_require__.e(7665).then(() => (() => (__webpack_require__(47665))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-error-boundary",
	},
	35054: {
		getter: () => (__webpack_require__.e(254).then(() => (() => (__webpack_require__(90254))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "diff",
	},
	42515: {
		getter: () => (__webpack_require__.e(2432).then(() => (() => (__webpack_require__(2432))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/rum-midway-credentials-provider",
	},
	42971: {
		getter: () => (__webpack_require__.e(9926).then(() => (() => (__webpack_require__(89926))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/awsui-components-react",
	},
	45899: {
		getter: () => (Promise.all([__webpack_require__.e(8318), __webpack_require__.e(6616)]).then(() => (() => (__webpack_require__(68318))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.5.6",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "json-as-xlsx",
	},
	48721: {
		getter: () => (__webpack_require__.e(6407).then(() => (() => (__webpack_require__(56407))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.11.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "antd",
	},
	52783: {
		getter: () => (__webpack_require__.e(9417).then(() => (() => (__webpack_require__(79417))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/awsui-global-styles",
	},
	53243: {
		getter: () => (__webpack_require__.e(5579).then(() => (() => (__webpack_require__(95579))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.2.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "http-status-codes",
	},
	57288: {
		getter: () => (__webpack_require__.e(3075).then(() => (() => (__webpack_require__(3075))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "pako",
	},
	60643: {
		getter: () => (__webpack_require__.e(7713).then(() => (() => (__webpack_require__(47713))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "9.3.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ag-charts-community",
	},
	67126: {
		getter: () => (__webpack_require__.e(4921).then(() => (() => (__webpack_require__(44921))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.4.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-use-websocket",
	},
	70513: {
		getter: () => (__webpack_require__.e(1621).then(() => (() => (__webpack_require__(81621))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.0.0-rc.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "zustand",
	},
	84019: {
		getter: () => (__webpack_require__.e(5811).then(() => (() => (__webpack_require__(15811))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.16.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "aws-rum-web",
	},
	89330: {
		getter: () => (__webpack_require__.e(8715).then(() => (() => (__webpack_require__(48715))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "module-federation-import-remote",
	},
	91650: {
		getter: () => (__webpack_require__.e(3243).then(() => (() => (__webpack_require__(63243))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@amzn/cathode-versions-javascript",
	},
	93448: {
		getter: () => (__webpack_require__.e(2508).then(() => (() => (__webpack_require__(32508))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.0.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "quill",
	},
	98657: {
		getter: () => (Promise.all([__webpack_require__.e(681), __webpack_require__.e(1411)]).then(() => (() => (__webpack_require__(40681))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.16.4",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/material",
	},
	41411: {
		getter: () => (__webpack_require__.e(1170).then(() => (() => (__webpack_require__(1170))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.11.8",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@popperjs/core",
	},
	46820: {
		getter: () => (__webpack_require__.e(9657).then(() => (() => (__webpack_require__(99657))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "uuid",
	}
};
var initialConsumes = [61229];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"943": [
		46820
	],
	"1411": [
		41411
	],
	"2157": [
		72157
	],
	"2939": [
		3244,
		12281,
		19310,
		19629,
		20630,
		22048,
		22082,
		26200,
		28285,
		29095,
		33171,
		35054,
		42515,
		42971,
		45899,
		48721,
		52783,
		53243,
		57288,
		60643,
		67126,
		70513,
		84019,
		89330,
		91650,
		93448,
		98657
	],
	"3008": [
		53008
	],
	"3983": [
		73983
	],
	"4550": [
		4550
	],
	"6391": [
		76391
	],
	"7411": [
		57411
	],
	"8250": [
		28250
	],
	"8308": [
		98308
	],
	"8792": [
		61229
	],
	"8862": [
		59883,
		64507,
		64761,
		86400
	],
	"9705": [
		79705
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}